/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC } from 'react'
import ReactWordcloud from 'react-wordcloud'
import 'tippy.js/dist/tippy.css'
import 'tippy.js/animations/scale.css'

type WordCloudProps = {
  words: { text: string; value: number }[]
  keySearch?: string
  width: number
  height: number
}
type Spiral = 'archimedean' | 'rectangular'
/**
 * WordCloud molecules
 * @constructor
 */
const WordCloud: FC<WordCloudProps> = ({ keySearch, words, width, height }) => {
  const totalArea = width * height
  const totalValue = words.reduce((sum, word) => sum + word.value, 0)

  const listFontSize = words.map(item => {
    const test = Math.sqrt(
      ((totalArea / totalValue) * item.value) / (item.text.length * 0.6),
    )
    return Math.floor(test * 0.7)
  })

  const minFontSize = Math.min(...listFontSize)
  const maxFontSize = Math.max(...listFontSize)
  const cappedMaxFontSize = Math.min(maxFontSize, 72)

  const options = {
    colors: [
      '#482677',
      '#60ca60',
      '#F8E621',
      '#355E8D',
      '#32B67A',
      '#29778D',
      '#2DB081',
      '#168A87',
      '#43095D',
    ],
    enableTooltip: true,
    deterministic: true,
    fontFamily: 'impact',
    fontSizes: [
      Math.min(minFontSize, cappedMaxFontSize),
      cappedMaxFontSize,
    ] as [number, number],
    fontStyle: 'normal',
    fontWeight: 'bold',
    padding: 1,
    rotations: 1,
    rotationAngles: [0, 90] as [number, number],
    spiral: 'rectangular' as Spiral,
  }

  const callbacks = {
    getWordColor: (word: any) =>
      word.text.toLowerCase() === keySearch?.toLowerCase() && keySearch !== ''
        ? 'red'
        : 'grey',
  }

  return (
    <ReactWordcloud
      callbacks={keySearch ? callbacks : undefined}
      options={options}
      words={words}
    />
  )
}

export default React.memo(WordCloud)
